import {adminApiClient} from 'src/api/ProactApiClientInstances';
import {registerOutboxExecutor} from './executorRegistry';
import type {OutboxExecutorResult} from './executorRegistry';
import {findSessionFile} from './files';

interface TestEchoPayload {
  message?: string;
  simulateFailure: boolean;
}

interface TestEchoFilePayload {
  refKey: string;
  message?: string;
}

// Dev-only executors for the offline test page. Registered from the offline
// composition root so the registry itself never imports the API client.
export const registerTestEchoExecutors = (): void => {
  registerOutboxExecutor(
    'test.echo',
    async (payload, clientSubmissionId): Promise<OutboxExecutorResult> => {
      const {message, simulateFailure} = payload as TestEchoPayload;
      const response = await adminApiClient.offlineEcho({
        clientSubmissionId,
        message,
        simulateFailure,
      });
      const receivedAt = new Date(response.receivedAtUtc).toLocaleTimeString();
      return {summary: `Echoed "${response.message ?? ''}" at ${receivedAt}`};
    }
  );

  registerOutboxExecutor(
    'test.echoFile',
    async (payload, clientSubmissionId, ctx): Promise<OutboxExecutorResult> => {
      const {refKey} = payload as TestEchoFilePayload;
      const file = await findSessionFile(ctx.sessionId, refKey);
      if (!file) {
        throw new Error(`No captured file found for refKey "${refKey}".`);
      }
      const meta = `${file.name} (${file.size} bytes, ${file.contentType})`;
      const response = await adminApiClient.offlineEcho({
        clientSubmissionId,
        message: `file:${meta}`,
        simulateFailure: false,
      });
      const receivedAt = new Date(response.receivedAtUtc).toLocaleTimeString();
      return {summary: `Echoed ${meta} at ${receivedAt}`};
    }
  );
};
